import React from 'react';
import './SkeletonLoader.css';

export const SkeletonLoader: React.FC = () => {
  return (
    <div className="skeleton-loader">
      {/* Header Section with Avatar and Text Lines */}
      <div className="skeleton-header">
        <div className="skeleton-avatar" />
        <div className="skeleton-text-group">
          <div className="skeleton-text skeleton-text-short" />
          <div className="skeleton-text skeleton-text-long" />
        </div>
      </div>

      {/* Large Card */}
      <div className="skeleton-card skeleton-card-large" />

      {/* Small Card Row */}
      <div className="skeleton-row">
        <div className="skeleton-card skeleton-card-small" />
        <div className="skeleton-card skeleton-card-tiny" />
      </div>

      {/* Medium Card */}
      <div className="skeleton-card skeleton-card-medium" />

      {/* Another Medium Card */}
      <div className="skeleton-card skeleton-card-medium" />

      {/* Bottom Button */}
      <div className="skeleton-button" />

      {/* Bottom Row */}
      <div className="skeleton-row">
        <div className="skeleton-card skeleton-card-small" />
        <div className="skeleton-card skeleton-card-tiny" />
      </div>
    </div>
  );
};
